import React from 'react'

const FireIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="fireGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 200, 100, 1)" />
          <stop offset="50%" stopColor="rgba(255, 140, 60, 1)" />
          <stop offset="100%" stopColor="rgba(255, 80, 50, 1)" />
        </linearGradient>
        <filter id="fireGlow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Main flame */}
      <path 
        d="M12 2c-1 3-2 5.5-2 8 0 2.5 1.5 4 3 4s3-1.5 3-4c0-2.5-1-5-2-8z"
        fill="url(#fireGradient)"
        filter="url(#fireGlow)"
      />
      
      {/* Left flame */}
      <path 
        d="M9 8c-1 2-1.5 3.5-1.5 5 0 2 1 3.5 2.5 3.5s2.5-1.5 2.5-3.5c0-1.5-0.5-3-1.5-5z"
        fill="rgba(255, 180, 80, 0.8)"
      />
      
      {/* Right flame */}
      <path 
        d="M15 8c1 2 1.5 3.5 1.5 5 0 2-1 3.5-2.5 3.5s-2.5-1.5-2.5-3.5c0-1.5 0.5-3 1.5-5z"
        fill="rgba(255, 180, 80, 0.8)"
      />
      
      {/* Inner glow */}
      <path 
        d="M12 6c-0.5 2-1 3.5-1 5 0 1.5 0.8 2.5 1.5 2.5s1.5-1 1.5-2.5c0-1.5-0.5-3-1-5z"
        fill="rgba(255, 230, 150, 0.6)"
      />
    </svg>
  )
}

export default FireIcon
